/**
 * Authorization Roles
 */
const authRoles = {
  admin: ['admin'],
  staff: ['admin', 'staff', 'sales'],
  supplier: ['admin', 'staff', 'supplier', 'sales'],
  customer: ['admin', 'staff', 'customer', 'sales'],
  users: ['admin', 'staff', 'supplier', 'customer', 'sales', 'vas designer', 'vas production', 'vas manager', 'warehouse employee', 'warehouse lead', 'inventory lookup'],
  withWarehouseStaff: ['admin', 'staff', 'sales', 'warehouse employee', 'warehouse lead'], // Added new authRoles to avoid giving permission to view Employees, customers and other routes
  onlyGuest: [],
  onlyCustomer: ['customer'],
  onlySupplier: ['supplier'],
  onlyStaffAndAdmin: ['staff', 'admin', 'sales'],
  vasUsers: ['vas designer', 'vas production', 'vas manager'],
  /**
   * PGSS-5715: a customer's read-only stock lookup login. In `users` (so sign-out and verify work) but
   * deliberately NOT in settingsConfig.defaultAuth, which keeps it out of every unguarded route.
   */
  inventoryLookup: ['inventory lookup'],
};

export default authRoles;
